import { createRoutine } from "redux-saga-routines";

// creating routine
export const fetchPricesRoutine = createRoutine("scatter/FETCH_PRICES");
